module.exports = __webpack_public_path__ + "static/2_1_search-2_IT-1e608f3f487974ad6dda9aeda93b4a34.svg";